import { Vue, Component, namespace } from 'nuxt-property-decorator'

const site = namespace('site')
@Component({})
export default class MixinRecaptcha extends Vue {
  @site.Getter('getApiKeyRecaptchaSiteKey') public getApiKeyRecaptchaSiteKey!:
    | string
    | null

  private recaptchaScript: HTMLScriptElement | null = null

  public mounted(): void {
    if (this.getApiKeyRecaptchaSiteKey && !window.grecaptcha) {
      this.recaptchaScript = document.createElement('script')
      this.recaptchaScript.src = `https://www.google.com/recaptcha/api.js?render=${this.getApiKeyRecaptchaSiteKey}`
      this.recaptchaScript.async = true
      document.body.appendChild(this.recaptchaScript)
    }
  }

  public destroyed(): void {
    if (this.recaptchaScript) {
      document.body.removeChild(this.recaptchaScript)
      this.recaptchaScript = null
      window.grecaptcha = null

      const badge = document.querySelector('.grecaptcha-badge')

      if (badge) {
        badge.remove()
      }
    }
  }
}
